module.exports = {
  locales: ['en', 'ja'],
}
